import firebase from 'firebase';
import '@firebase/firestore'
import fbconfig from '../../fbconfig'

const config = {//firebase project configuration
  apiKey: "AIzaSyBRPh1eHImgjlKAFogiXod50FMFKoQyazA",
  authDomain: "midasshipping-c9c2e.firebaseapp.com",
  databaseURL: "https://midasshipping-c9c2e.firebaseio.com",
  projectId: "midasshipping-c9c2e",
  storageBucket: "midasshipping-c9c2e.appspot.com",
  messagingSenderId: "902008991823",
  appId: "1:902008991823:web:0f20e9e6a4fc54d6483a3a",
  measurementId: "G-7QQFZCSWYF"
};
// Initialize Firebase
firebase.initializeApp(config);
//firebase.analytics();

   
export async function addContact(order, addComplete) {
  console.log('in Contact')
  firebase.auth().signInAnonymously()
  order.timeOpened = firebase.firestore.FieldValue.serverTimestamp();
  await firebase.firestore()
    .collection('Contact')
    .add(order)
    .then((snapshot) => {
      order.id = snapshot.id;
      snapshot.set(order);
    }).then(() => addComplete(order))
    .catch((error) => console.log(error));
    console.log('out Contact')
}

export async function addAirFreight(order, addComplete) {
  console.log('in AirFreight')
  firebase.auth().signInAnonymously()
  order.timeOpened = firebase.firestore.FieldValue.serverTimestamp();
  await firebase.firestore()
    .collection('Requests')
    .add(order)
    .then((snapshot) => {
      order.id = snapshot.id;
      snapshot.set(order);
    }).then(() => addComplete(order))
    .catch((error) => console.log(error));
    console.log('out AirFreight')
}

export async function addRORO(order, addComplete) {
  console.log('in RORO')
  firebase.auth().signInAnonymously()
  order.timeOpened = firebase.firestore.FieldValue.serverTimestamp();
  await firebase.firestore()
    .collection('Requests')
    .add(order)
    .then((snapshot) => {
      order.id = snapshot.id;
      snapshot.set(order);
    }).then(() => addComplete(order))
    .catch((error) => console.log(error));
    console.log('out RORO')
}

export async function addContainer(order, addComplete) {
  console.log('in Container')
  firebase.auth().signInAnonymously()
  order.timeOpened = firebase.firestore.FieldValue.serverTimestamp();
  await firebase.firestore()
    .collection('Requests')
    .add(order)
    .then((snapshot) => {
      order.id = snapshot.id;
      snapshot.set(order);
    }).then(() => addComplete(order))
    .catch((error) => console.log(error));
    console.log('out Container')
}



export default firebase;
